(function () {

    function initializeNewbornBasics() {

        const sliders = document.querySelectorAll('.newbornSwiper');

        if (!sliders.length) {
            return;
        }

        /* --------------------------------
           Check if Swiper is available
        -------------------------------- */

        if (typeof window.Swiper === 'undefined') {

            setTimeout(function () {
                initializeNewbornBasics();
            }, 300);

            return;
        }


        sliders.forEach(function (slider) {

            const section = slider.closest('.newborn-basics');

            if (!section) {
                return;
            }


            /* --------------------------------
               Prevent duplicate initialization
            -------------------------------- */

            if (slider.swiper) {
                return;
            }


            /* --------------------------------
               Section Settings
            -------------------------------- */

            const autoplayEnabled =
                section.dataset.autoplay === 'true';

            const autoplaySpeed =
                (parseInt(section.dataset.speed, 10) || 4) * 1000;

            const loopEnabled =
                section.dataset.loop === 'true';

            const navigationEnabled =
                section.dataset.navigation === 'true';

            const paginationEnabled =
                section.dataset.pagination === 'true';


            /* --------------------------------
               Navigation Elements
            -------------------------------- */

            const nextButton =
                section.querySelector('.nb-next');

            const prevButton =
                section.querySelector('.nb-prev');

            const pagination =
                section.querySelector('.nb-pagination');


            /* --------------------------------
               Initialize Swiper
            -------------------------------- */

            const swiper = new window.Swiper(slider, {

                /*
                 * MOBILE
                 */

                slidesPerView: 2,

                slidesPerGroup: 1,

                spaceBetween: 12,


                /*
                 * GENERAL
                 */

                speed: 600,

                loop: loopEnabled,

                watchOverflow: false,

                observer: true,

                observeParents: true,


                /*
                 * AUTOPLAY
                 */

                autoplay: autoplayEnabled
                    ? {
                        delay: autoplaySpeed,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    }
                    : false,


                /*
                 * NAVIGATION
                 */

                navigation: navigationEnabled
                    ? {
                        nextEl: nextButton,
                        prevEl: prevButton
                    }
                    : false,


                /*
                 * PAGINATION
                 */

                pagination: paginationEnabled
                    ? {
                        el: pagination,
                        clickable: true
                    }
                    : false,


                /*
                 * RESPONSIVE
                 */

                breakpoints: {

                    /*
                     * Mobile
                     * 0 - 575px
                     */

                    0: {

                        slidesPerView: 2,

                        slidesPerGroup: 1,

                        spaceBetween: 12

                    },


                    /*
                     * Small Tablet
                     * 576 - 767px
                     */

                    576: {

                        slidesPerView: 2,

                        slidesPerGroup: 1,

                        spaceBetween: 15

                    },


                    /*
                     * Tablet
                     * 768 - 991px
                     */

                    768: {

                        slidesPerView: 3,

                        slidesPerGroup: 1,

                        spaceBetween: 20

                    },


                    /*
                     * Desktop
                     * 992 - 1199px
                     */

                    992: {

                        slidesPerView: 4,

                        slidesPerGroup: 1,

                        spaceBetween: 22

                    },


                    /*
                     * Large Desktop
                     * 1200px+
                     */

                    1200: {

                        slidesPerView: 5,

                        slidesPerGroup: 1,

                        spaceBetween: 24

                    }

                }

            });


            /*
             * Force update after initialization
             */

            setTimeout(function () {

                if (swiper && !swiper.destroyed) {

                    swiper.update();

                }

            }, 100);

        });

    }


    /* --------------------------------
       Initial Load
    -------------------------------- */

    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            initializeNewbornBasics
        );

    } else {

        initializeNewbornBasics();

    }


    /* --------------------------------
       Shopify Theme Editor
    -------------------------------- */

    document.addEventListener(
        'shopify:section:load',
        function (event) {

            if (
                event.target &&
                event.target.querySelector('.newbornSwiper')
            ) {

                setTimeout(
                    initializeNewbornBasics,
                    200
                );

            }

        }
    );


})();